import { AnalyticsEvents, EventConfig } from 'app/shared/u21-ui/analytics';
import { U21DatePickerProps } from 'app/shared/u21-ui/components';

export const onchange: EventConfig<U21DatePickerProps['value']> = {
  name: 'U21DatePicker changed',
  createPayload: (props, _, date) => {
    const name = props.label || props['aria-label'] || props.name;
    if (!name) {
      return null;
    }
    return { date, name };
  },
};

export const u21DatePickerEvents = {
  [AnalyticsEvents.U21DATEPICKER_ON_CHANGE]: onchange,
};
